import React from 'react';

const AsyncInfluencersListPage = React.lazy(() => import('../List/InfluencersListContainer'));

export const InfluencersListPage = () => {
  return <AsyncInfluencersListPage />;
};
